(ns frontend.ux-overhaul.listing.person.view
  (:require [common.localization :as loc]
            [common.opensearch.row :as os-row]
            [frontend.routing :as routing]
            [frontend.ux-overhaul.listing.generic.bulk-actions :as bulk-actions]
            [frontend.ux-overhaul.listing.generic.event :as generic-event]
            [frontend.ux-overhaul.listing.generic.facets-event :as generic-facets-event]
            [frontend.ux-overhaul.listing.generic.menu-actions :as menu-actions]
            [frontend.ux-overhaul.listing.generic.view :as listing]
            [frontend.ux-overhaul.listing.person.event :as person-event]
            [re-frame.core :as rf]
            [reagent.core :as r]))

(def listing-id "person-listing")

(defn- open-person!
  [value]
  (when-let [entity-id (os-row/entity-id value)]
    (routing/open-entity {:db/id       entity-id
                          :entity/type :entity.type/person})))

(def page-content
  (r/create-class
   {:component-did-mount
    (fn []
      (rf/dispatch
       [::generic-event/init
        {:listing-id           listing-id
         :entity-type          :entity.type/person
         :pipeline-id          nil
         :filters              {:enabled? true
                                :view-id :person
                                :load-facets-event [::generic-facets-event/load-facets]}
         :available-view-modes #{:grid :kanban :gallery :list}
         :toolbar-actions      [{:id       :create-person
                                 :label    (loc/tr :contact-add-button)
                                 :visible? true
                                 :enabled? true
                                 :event    [::person-event/create-person]}
                                {:id                  :bulk-edit-persons
                                 :label               (loc/tr :bulk-edit)
                                 :visible?            true
                                 :enabled?            true
                                 :requires-selection? true
                                 :event               [::person-event/open-bulk-edit {:listing-id listing-id}]}
                                {:id                  :bulk-delete-persons
                                 :label               (loc/tr :confirm-delete-selected-button)
                                 :visible?            true
                                 :enabled?            true
                                 :requires-selection? true
                                 :variant             :danger
                                 :event               [::person-event/bulk-delete-selected {:listing-id listing-id}]}
                                {:id       :export-persons
                                 :label    (loc/tr :save-as-excel)
                                 :visible? true
                                 :enabled? true
                                 :event    [::person-event/export-grid {:listing-id listing-id}]}
                                (menu-actions/field-requirements-action {:entity-type :entity.type/person})
                                (menu-actions/landing-page-action {:view-id :persons-grid})]}]))

    :component-will-unmount
    (fn []
      (rf/dispatch [::generic-event/destroy listing-id]))

    :reagent-render
    (fn []
      [:<>
       [listing/view
        {:listing-id               listing-id
         :title                    (loc/tr :contacts)
         :show-view-mode-selector? true
         :query-placeholder        (loc/tr :listing.person/search-placeholder)
         :on-create-first-item     #(rf/dispatch [::person-event/create-person])
         :on-row-clicked           open-person!
         :on-card-clicked          open-person!}]
       [bulk-actions/bulk-edit-modal
        {:listing-id  listing-id
         :entity-type :entity.type/person}]
       [menu-actions/field-requirements-modal]])}))
